// v6 - July 6 2026 — USA vs Belgium (Round of 16)
window.USA_GOALS = 0;
window.GAME_ACTIVE = false;
window.GAME_ENDED = false;
window.GAME_ENDED_AT = null;
window.GOAL_CAP = 6;

window.GT_DATA = {
  0: {msg:'USA is playing! Goals are being tracked — check back at the final whistle for your discount.',disc:null,code:null},
  1: {msg:'USA scored 1 goal! Your 5% extra discount is now active for 48 hours.',disc:'5% Extra Off',code:'USAGOAL5'},
  2: {msg:'USA scored 2 goals! Your 10% extra discount is now active for 48 hours.',disc:'10% Extra Off',code:'USAGOAL10'},
  3: {msg:'USA scored 3 goals! Your 15% extra discount is now active for 48 hours.',disc:'15% Extra Off',code:'USAGOAL15'},
  4: {msg:'USA scored 4 goals! Your 20% extra discount is now active for 48 hours.',disc:'20% Extra Off',code:'USAGOAL20'},
  5: {msg:'USA scored 5 goals! Your 25% extra discount is now active for 48 hours.',disc:'25% Extra Off',code:'USAGOAL25'},
  6: {msg:'USA scored 6+ goals! Maximum 25% extra off — active for 48 hours.',disc:'25% Extra Off',code:'USAGOAL25'}
};

window.gtInit = function() {
  var tracker = document.getElementById('rbh-wmt-goal-tracker');
  var inner = document.getElementById('rbh-gt-inner');
  if (!tracker || !inner) return;

  // Check 48-hour expiry
  if (window.GAME_ENDED && window.GAME_ENDED_AT) {
    var hoursSinceEnd = (Date.now() - window.GAME_ENDED_AT) / 3600000;
    if (hoursSinceEnd >= 48) {
      // Expired — reset to idle
      tracker.style.display = 'block';
      tracker.classList.remove('rbh-wmt-goal-tracker--active');
      inner.innerHTML = '<span class="rbh-wmt-goal-tracker__idle">&#x26BD;&nbsp; Every USA goal = extra 5% off &mdash; Code activates at the final whistle</span>';
      var alertEl = document.getElementById('rbh-sb-usa-alert');
      if (alertEl) alertEl.style.display = 'none';
      return;
    }
  }

  if (!window.GAME_ACTIVE) return;

  var g = Math.min(window.USA_GOALS, window.GOAL_CAP);
  var d = window.GT_DATA[g];
  tracker.classList.add('rbh-wmt-goal-tracker--active');
  var html = '<span class="rbh-wmt-goal-tracker__pulse"></span>';

  if (window.GAME_ENDED && window.USA_GOALS > 0) {
    var hoursLeft = Math.floor(Math.max(0, 48 - ((Date.now() - window.GAME_ENDED_AT) / 3600000)));
    html += '<div style="display:flex;flex-direction:column;align-items:center">';
    html += '<span class="rbh-wmt-goal-tracker__goals">&#x26BD; ' + window.USA_GOALS + '</span>';
    html += '<span class="rbh-wmt-goal-tracker__label">USA Goals Scored</span></div>';
    html += '<p class="rbh-wmt-goal-tracker__message">' + d.msg + ' Expires in ' + hoursLeft + ' hours.</p>';
    html += '<span class="rbh-wmt-goal-tracker__discount">' + d.disc + '</span>';
    html += '<span class="rbh-wmt-goal-tracker__code">' + d.code + '</span>';
  } else if (window.GAME_ENDED && window.USA_GOALS === 0) {
    html += '<p class="rbh-wmt-goal-tracker__message">No goals this match. Check back for the next USA game.</p>';
  } else {
    html += '<p class="rbh-wmt-goal-tracker__message">&#x26BD;&nbsp; USA is playing — goals are being tracked. Your discount code activates at the final whistle.</p>';
  }

  inner.innerHTML = html;
};

document.addEventListener('DOMContentLoaded', function() {
  window.gtInit();
});